import {
  StepLabel as MuiStepLabel,
  stepLabelClasses,
  styled,
} from '@mui/material';

export const StepLabel = styled(MuiStepLabel)({
  [`&.${stepLabelClasses.vertical}`]: {
    alignItems: 'flex-start',
  },
  [`& .${stepLabelClasses.iconContainer}`]: {
    marginTop: '8px',
    marginBottom: '8px',
  },
  [`&.${stepLabelClasses.root}`]: {
    padding: 0,
  },
  [`& .${stepLabelClasses.label}`]: {
    color: 'grey',
    [`&.${stepLabelClasses.active}`]: {
      color: 'white',
    },
    [`&.${stepLabelClasses.completed}`]: {
      color: 'white',
    },
  },
});
